import { render, staticRenderFns } from "./UvozTahografa.vue?vue&type=template&id=6843ae71&scoped=true&"
import script from "./UvozTahografa.vue?vue&type=script&lang=ts&"
export * from "./UvozTahografa.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6843ae71",
  null
  
)

export default component.exports